import App from 'app/app.js';

function ErrorLogService($log, $window) {
  return function (exception, cause) {
    $log.error.apply($log, arguments);
    try {
      var errorMessage = exception.toString();
      var stackTrace = printStackTrace({ e: exception });
      $.ajax({
        type: 'POST',
        url: 'error/log',
        contentType: 'application/json',
        data: angular.toJson({
          errorUrl: $window.location.href,
          errorMessage: errorMessage,
          stackTrace: stackTrace,
          cause: cause || ''
        })
      });
    } catch (loggingError) {
      $log.warn('Error logging failed');
      $log.log(loggingError);
    }
    if (typeof Sentry !== 'undefined' && typeof Sentry.captureException === 'function') {
      Sentry.captureException(exception instanceof Error ? exception : new Error(String(exception)));
    }
  };
}

App.factory('ErrorLogService', ['$log', '$window', ErrorLogService]);

App.provider('$exceptionHandler', {
  $get: [
    'ErrorLogService',
    function (ErrorLogService) {
      return ErrorLogService;
    }
  ]
});
